<template>
  <section>
    <header>
      <span>Единицы измерения</span>
      <VLink
        material="add"
        @click="ProductCategoriesService.showProductCategoryAllowedUnitsDialog(productCategory)"
      >
        Добавить
      </VLink>
    </header>

    <div class="content">
      <VDataGridV2
        layout="fill"
        :data="allowedUnits"
      >
        <VDataGridColumnV2
          id="id"
          label="ID"
          width="80px"
        />

        <VDataGridColumnV2
          id="name"
          label="Название"
        />

        <VDataGridColumnV2
          id="action"
          width="105px"
          content-align="right"
        >
          <template #default="{ row }">
            <VButton
              :disabled="ProductCategoriesService.getReasonCannotDetachUnit(productCategory) !== null"
              :title="ProductCategoriesService.getReasonCannotDetachUnit(productCategory)"
              material="delete"
              @click="detachUnit(row)"
            />
          </template>
        </VDataGridColumnV2>
      </VDataGridV2>
    </div>
  </section>
</template>

<script lang="ts">

import ProductCategoriesService from '@/domains/ProductCategories/ProductCategoriesService';

export default defineComponent({
	name: 'ProductCategoryAllowedUnits',

	props: {
		productCategory: {
			type:    Object,
			default: null,
		},
	},

	emits: ['change'],

	setup() {
		return {
			ProductCategoriesService,
		};
	},

	computed: {
		/** Имеется ли у продуктовой категории список разрешённых единиц измерения */
		haveAllowedUnits(): boolean {
			return (
				this.$core.utils.isObject(this.productCategory)
				&& Array.isArray(this.productCategory.allowedUnits)
				&& this.productCategory.allowedUnits.length > 0
			);
		},

		/** Список разрешённых единиц измерения для отображения в таблице */
		allowedUnits(): any[] {
			return this.haveAllowedUnits ? this.productCategory.allowedUnits : [];
		},
	},

	methods: {
		/**
		 * Отвязать единицу измерения от категории
		 */
		async detachUnit(unit: any): Promise<void> {
			if (await ProductCategoriesService.detachAllowedUnit(this.productCategory.id, unit.id) === true) {
				this.$emit('change');
			}
			else {
				// ошибку показал сервис
			}
		},
	},
});
</script>